import React from 'react';
import styles from '../GuidanceCard.scss';
import ViewCounterRow from './ViewCounterRow';
import CounterHeader from './CounterHeader';
import { useWwsViewCountQuery } from '../../../../generated/graphql';
import honeybadger from 'honeybadger-js';
import { handleOverride, parseCookieOverrides } from './counterHelper';
import { VIEW_TRACKER_OVERRIDE_COOKIES } from '../../../../constants';
import { get } from 'js-cookie';

const ViewTrackerCard = () => {
  const { data, error } = useWwsViewCountQuery();

  if (error) {
    honeybadger.notify({
      name: 'WWS View Tracker',
      message: 'Error fetching view count data.',
      context: { error },
    });

    return null;
  }

  const overrides = {
    total: parseCookieOverrides(get(VIEW_TRACKER_OVERRIDE_COOKIES.TOTAL)),
    weekly: parseCookieOverrides(get(VIEW_TRACKER_OVERRIDE_COOKIES.WEEKLY)),
  };

  const total = handleOverride(overrides.total, data?.wwsViewCount?.website_visitors_total || 0);
  const weekly = handleOverride(overrides.weekly, data?.wwsViewCount?.website_visitors_recent || 0);

  return (
    <div data-testid="view-tracker-card" className={`${styles.viewTrackerCard} ${styles.card}`}>
      <CounterHeader />
      <ViewCounterRow totalNum={total} weeklyNum={weekly} />
    </div>
  );
};

export default ViewTrackerCard;
